/**
 * MediaPipe selfie segmentation — one instance per compositor (no shared singleton).
 * Always close() the previous instance before creating the next; an open WASM/GL
 * session leaves later modules stuck on a still background or black video.
 */

import { SelfieSegmentation } from '@mediapipe/selfie_segmentation';

const MEDIAPIPE_SELFIE_VERSION = '0.1.1675465747';

let createChain = Promise.resolve();

export async function createPitchSelfieSegmenter() {
  const run = async () => {
    const segmenter = new SelfieSegmentation({
      locateFile: (file) =>
        `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation@${MEDIAPIPE_SELFIE_VERSION}/${file}`,
    });
    segmenter.setOptions({
      modelSelection: 0,
      // We mirror the camera ourselves so mask + video stay aligned.
      selfieMode: false,
    });
    if (typeof segmenter.initialize === 'function') {
      try {
        await segmenter.initialize();
      } catch {
        /* older bundles initialize on first send */
      }
    }
    return segmenter;
  };
  // Serialize creates so remounts between pitch modules don't race two WASM loads.
  const next = createChain.then(run, run);
  createChain = next.then(() => undefined, () => undefined);
  return next;
}

export function closePitchSelfieSegmenter(segmenter) {
  if (!segmenter) return;
  try {
    segmenter.onResults?.(() => {});
  } catch {
    /* ignore */
  }
  try {
    segmenter.reset?.();
  } catch {
    /* ignore */
  }
  try {
    segmenter.close?.();
  } catch {
    /* ignore */
  }
}
